import "./MobCouponModal.scss";

/**
 * Compact mobile coupon picker — same look as cart (ticket cards).
 * Used by order-summary (and cart).
 */
export function MobCouponModal({
    open,
    onClose,
    coupons = [],
    selectedCoupon,
    onSelect,
    orderTotal = 0,
}) {
    if (!open) return null;

    return (
        <div
            className="coupon-modal-overlay mob-cart-coupon-modal"
            onClick={onClose}
            role="presentation"
        >
            <div className="coupon-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="mob-coupon-modal-title">
                <div className="coupon-modal-header">
                    <h2 id="mob-coupon-modal-title">Available Coupons</h2>
                    <button type="button" className="close-modal-btn" onClick={onClose} aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                            <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
                <div className="coupon-modal-content">
                    <div className="coupons-list">
                        {coupons.map((coupon) => {
                            const isApplicable = orderTotal >= coupon.minOrder;
                            const amountShort = coupon.minOrder - orderTotal;
                            const isSelected = selectedCoupon?.id === coupon.id;

                            return (
                                <div
                                    key={coupon.id}
                                    className={`coupon-card${!isApplicable ? " disabled" : ""}${isSelected ? " selected" : ""}`}
                                    onClick={() => isApplicable && onSelect?.(coupon)}
                                >
                                    <div className="coupon-discount" aria-hidden="true">
                                        <span className="coupon-discount__value">
                                            {coupon.type === "percentage" ? `${coupon.discount}%` : `₹${coupon.discount}`}
                                        </span>
                                        <span className="coupon-discount__label">OFF</span>
                                    </div>
                                    <div className="coupon-card-main">
                                        <div className="coupon-code">{coupon.code}</div>
                                        <div className="coupon-description">{coupon.description}</div>
                                        {!isApplicable ? (
                                            <div className="coupon-min-order">
                                                Add ₹{amountShort.toLocaleString("en-IN")} more to unlock
                                            </div>
                                        ) : null}
                                    </div>
                                    {isApplicable && (
                                        <button
                                            type="button"
                                            className="apply-coupon-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onSelect?.(coupon);
                                            }}
                                            aria-label={
                                                isSelected
                                                    ? `Coupon ${coupon.code} applied`
                                                    : `Apply coupon ${coupon.code}`
                                            }
                                        >
                                            {isSelected ? (
                                                <>
                                                    <span className="apply-coupon-btn__check" aria-hidden="true">
                                                        ✓
                                                    </span>
                                                    Applied
                                                </>
                                            ) : (
                                                "Apply"
                                            )}
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
